import { ChangeEvent, Dispatch, SetStateAction } from "react";

import {
  Button,
  CloseSVG,
  Icon,
  SearchSVG,
  type SvgComponentType,
} from "@newsela/angelou";

import {
  condensedCloseButtonCss,
  condensedInputContainerCss,
  condensedPopoutSearchBarVisibilityCss,
  condensedSearchCloseIconCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/CondensedSearchInput/CondensedSearchInput.styles";
import {
  absoluteSearchIconCss,
  inputFieldCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/SearchMenu.styles";

const CondensedSearchInput = ({
  inputValue,
  onChange,
  onKeyDown,
  onClick,
  setShowSuggestions,
}: ICondensedSearchInput) => {
  return (
    <div css={condensedInputContainerCss}>
      <div css={condensedPopoutSearchBarVisibilityCss}>
        <Icon
          SvgComponent={SearchSVG as SvgComponentType}
          __cssFor={absoluteSearchIconCss}
        />
        <input
          autoComplete="off"
          value={inputValue}
          data-qa-selector="global-nav-search"
          onChange={(event) => {
            onChange(event);
            setShowSuggestions(true);
          }}
          // @ts-expect-error typescript is complaining about the KeyboardEvent
          onKeyDown={onKeyDown}
          css={inputFieldCss}
          placeholder="Search for texts and more"
        />
      </div>

      <Button
        onClick={onClick}
        ariaProps={{ "aria-label": "Close search" }}
        flavor={Button.flavors.incognito}
        __cssFor={condensedCloseButtonCss}
      >
        <Icon
          SvgComponent={CloseSVG as SvgComponentType}
          __cssFor={condensedSearchCloseIconCss}
        />
      </Button>
    </div>
  );
};

interface ICondensedSearchInput {
  inputValue: string;
  onClick: () => void;
  onKeyDown: (event: KeyboardEvent) => void;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  setShowSuggestions: Dispatch<SetStateAction<boolean>>;
}

CondensedSearchInput.displayName = "CondensedSearchInput";
export { CondensedSearchInput };
